import { useLocation } from '@tanstack/react-router';
import { useMemo } from 'react';

export function useQuery() {
  const location = useLocation();
  return useMemo(() => new URLSearchParams(location.searchStr), [location.searchStr]);
}
